module.exports = __webpack_public_path__ + "static/media/appstore-btn.ceadcffc.png";